import script from "./PersonalDetailsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./PersonalDetailsPage.vue?vue&type=script&setup=true&lang=js"

import "./PersonalDetailsPage.vue?vue&type=style&index=0&id=08cb50e2&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/claims-portal/claims-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08cb50e2"]])

export default __exports__